module.exports = __webpack_public_path__ + "img/ico_wgfw.61670fb1.png";